import {GenericObject} from 'components/customer/Product/entity';
import {ProductDefault} from 'components/customer/Product/entity/ProductDefault';
import {Drawer} from 'components/customer/Product/entity/Drawer';
import {Shelf} from 'components/customer/Product/entity/Shelf';

export interface InitialValues extends GenericObject {
    glassSubPanels: boolean[][];
    drawers?: Drawer[];
    drawer_amount?: number;
    cabinet_top?: number;
    door_hinge_amount?: number;
    door_hinge_amount_1?: number;
    shelves?: Shelf[];
    upper_shelves?: Shelf[];
    lower_shelves?: Shelf[];
    middle_shelves?: Shelf[];
    cabinet_include_hardware?: number;
    cabinet_adjustable_legs?: number;
    cabinet_simple_shelves?: boolean;
    cabinet_width?: number;
    cabinet_left_width?: number;
    cabinet_right_width?: number;
    cabinet_depth?: number;
    cabinet_left_depth?: number;
    cabinet_right_depth?: number;
    cabinet_hori_shelves?: number;
    cabinet_vert_shelves?: number;
    simple_shelves_amount?: number;
    drill_only_hinge_name?: string;
}

export const mapDefaults = (
    initialValues: InitialValues,
    defaultValues: ProductDefault
) => {
    if (
        defaultValues &&
        defaultValues.hasOwnProperty('cabinet_form_field_defaults') &&
        defaultValues.hasOwnProperty('cabinet_form_fields')
    ) {
        const defualtOverrides = Object.keys(
            defaultValues.cabinet_form_fields
        ).filter((key) => {
            return [1, 2].includes(
                defaultValues.cabinet_form_fields[String(key)]
            );
        });

        initialValues.glassSubPanels = [
            [false, false, false],
            [false, false, false],
            [false, false, false],
        ];

        Object.keys(defaultValues.cabinet_form_field_defaults).forEach(
            (formField) => {
                if (defualtOverrides.includes(formField)) {
                    if (formField.indexOf('sub_panel') >= 0) {
                        const subPanelIndex = parseInt(
                            formField.match(/\d+/g)[0]
                        );
                        const row = Math.floor((subPanelIndex - 1) / 3);
                        const col = (subPanelIndex - 1) % 3;

                        initialValues.glassSubPanels[Number(row)][Number(col)] =
                            defaultValues.cabinet_form_field_defaults[
                                String(formField)
                            ] == '1';
                        return;
                    }

                    if (
                        formField == 'hori_amount' ||
                        formField == 'vert_amount'
                    ) {
                        initialValues[String(formField)] = parseInt(
                            defaultValues.cabinet_form_field_defaults[
                                String(formField)
                            ]
                        );
                        return;
                    }
                    let value: string | number | boolean =
                        defaultValues.cabinet_form_field_defaults[
                            String(formField)
                        ];

                    // Apparently value == 2 is value == 1
                    if (value == '2' && formField !== 'drawer_face_type')
                        value = 1;

                    if (
                        [
                            'double_sided_carc',
                            'double_sided_ext',
                            'hor_grain_carc',
                            'hor_grain_ext',
                        ].includes(formField)
                    ) {
                        value = value == 1;
                    }

                    initialValues[String(formField)] = value;
                }
            }
        );
    }

    return initialValues;
};

export const applyAdvancedDoorDrawerFaceTypeDefault = (
    initialValues: InitialValues,
    isDoorAdvanced: boolean | undefined
) => {
    if (initialValues.hasOwnProperty('drawer_face_type') && isDoorAdvanced) {
        initialValues.drawer_face_type = 1;
    }

    return initialValues;
};
